import { SimpleFlex } from '@eversports/react-components/primitives/Flex'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import Location from '../../../typings/Location'

const hasField = (field: string | undefined) => field && field.trim().length > 0

const formatLocation = (location: Location) => {
  const { street, detail: doorNumber, zip, city } = location

  const streetAndNumber = hasField(doorNumber) ? `${street} ${doorNumber}` : street
  const zipAndCity = hasField(zip) && hasField(city) ? `, ${zip} ${city}` : ''

  return streetAndNumber.concat(zipAndCity)
}

interface Props {
  location: Location
  variant?: 'normal' | 'subtle'
}

const Address: React.FC<React.PropsWithChildren<Props>> = ({ location, variant = 'normal' }) => {
  const locationString = formatLocation(location)
  return (
    <SimpleFlex>
      <Icon icon={Icons.LOCATION} color="subtleText" marginRight="dense" />
      <Text
        fontWeight={variant === 'normal' ? 'bold' : 'normal'}
        color={variant === 'normal' ? 'text.primary' : 'subtleText'}
        size="small"
      >
        {locationString}
      </Text>
    </SimpleFlex>
  )
}

export default Address
